import React, { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

const READY = [
  "Sources confirm: this party is officially out of control",
  "Exclusive: guests refuse to leave the dance floor",
  "Caught on camera: the happiest people alive",
  "Love is in the air and the paparazzi got it",
  "Shock as open bar declared 'the best in history'",
  "Insiders say this couple is locked in forever",
];

export function HeadlinePicker({ slug, item, onPick }) {
  const [ai, setAi] = useState(item.ai_headlines || []);
  const [busy, setBusy] = useState(false);
  async function write() {
    setBusy(true);
    try {
      const { data } = await api.post(`/public/weddings/${slug}/memories/${item.item_id}/ai-headlines?token=${item.share_token}`);
      setAi(data.headlines);
      if (data.headlines[0]) onPick(data.headlines[0]);
      if (data.limited) toast("That's the max AI tries for this photo — pick one below");
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  }
  const chip = (h, i, kind) => (
    <button key={`${kind}-${i}`} onClick={() => onPick(h)} className={`text-left text-xs px-3 py-1.5 rounded-full border transition-colors hover:bg-[var(--ink)] hover:text-white ${kind === "ai" ? "border-[var(--gold)]" : "border-[var(--line)]"}`} data-testid={`headline-${kind}-${i}-${item.item_id}`}>{h}</button>
  );
  return (
    <div className="space-y-2">
      <button onClick={write} disabled={busy} className="text-xs flex items-center gap-1.5 text-[var(--gold)] font-medium" data-testid={`news-ai-headline-${item.item_id}`}>
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Sparkles className="w-3.5 h-3.5" />} {busy ? "Writing headlines…" : "Let AI write a funny headline"}
      </button>
      {ai.length > 0 && <div className="flex flex-wrap gap-1.5" data-testid={`news-ai-list-${item.item_id}`}>{ai.map((h, i) => chip(h, i, "ai"))}</div>}
      <details className="text-xs">
        <summary className="cursor-pointer text-[var(--muted)]" data-testid={`news-ready-toggle-${item.item_id}`}>Or pick a ready-made headline</summary>
        <div className="flex flex-wrap gap-1.5 mt-2">{READY.map((h, i) => chip(h, i, "ready"))}</div>
      </details>
    </div>
  );
}
